export const SHOW_MODAL = 'SHOW_MODAL'
export const HANDLE_SWITCH = 'HANDLE_SWITCH'
export const COUNTER_SIM = 'COUNTER_SIM'
export const TARIFF_RADIO_PLAN = 'TARIFF_RADIO_PLAN'
export const CHANGE_PLAN = 'CHANGE_PLAN'
export const SUM_TOTAL_PRICE = 'SUM_TOTAL_PRICE'
export const HANDLE_SWITCH_ALMOND = 'HANDLE_SWITCH_ALMOND'
export const HANDLER_COUNTER_ALMOND = 'HANDLE_COUNTER_ALMOND'
export const SUM_ALMOND_TOTAL_PRICE = 'SUM_ALMOND_TOTAL_PRICE'
export const CHANGE_ALMOND_TOTAL_PRICE = 'CHANGE_ALMOND_TOTAL_PRICE'
export const HANDLER_COUNTER_ALMOND_EQ = 'EQUIPMENTS/HANDLER_COUNTER_ALMOND_EQ'
export const SUM_ALMOND_TOTAL_PRICE_EQ = 'EQUIPMENTS/SUM_ALMOND_TOTAL_PRICE_EQ'
export const HANDLE_SWITCH_ALMOND_EQ = 'EQUIPMENTS/HANDLE_SWITCH_ALMOND_EQ'
export const SET_CHANNELS = 'SET_CHANNELS'
export const UNITE_SWITCH = 'UNITE_SWITCH'
